import { render } from "./xtx-pagination.vue?vue&type=template&id=e38dfd8a&scoped=true"
import script from "./xtx-pagination.vue?vue&type=script&lang=js"
export * from "./xtx-pagination.vue?vue&type=script&lang=js"

import "./xtx-pagination.vue?vue&type=style&index=0&id=e38dfd8a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38dfd8a"]])

export default __exports__